//基础页面
import Login from './views/Login.vue'
import LoginOut from './views/LoginOut.vue'
import NotFound from './views/404.vue'


import Index from './views/Index.vue'
import Home from './views/Home.vue'
//import Main from './views/Main.vue'
//import Application from './views/nav2/Application.vue'

//权限管理
import Roleuser from './views/role/Roleuser.vue'
import MenusList from './views/role/MenusList.vue'
import Roles from './views/role/Roles.vue'
import confJs from './views/role/confJs.vue'
import baseReport from './views/role/baseReport.vue'
import info from './views/role/info.vue'

import report from './views/adx/report.vue'
import reports from './views/adx/reports.vue'

import spInfo from './views/adx/spInfo.vue'
import cpinfo from './views/adx/cpinfo.vue'
import siteinfo from './views/adx/siteinfo.vue'
import htmlLog from './views/adx/htmlLog.vue'
import Rtreport9933 from './views/adx/Rtreport9933.vue'
import cpDzd from './views/adx/cpDzd.vue'
import checkData from './views/adx/checkData.vue'
import siteList from './views/adx/siteList.vue'
import jsConf from './views/adx/jsConf.vue'
import sitesinfo from './views/adx/sitesinfo.vue'
import sitesinfoManager from './views/adx/sitesinfoManager.vue'

import dclist from './views/study/dclist.vue'


//Sp数据
import spSpInfo from './views/sppro/spinfo.vue'
import spSpConf from './views/sppro/spConf.vue'
import spCpInfo from './views/sppro/cpinfo.vue'
import spService from './views/sppro/service.vue'
import queryList from './views/sppro/reqData.vue'
import spreport from './views/sppro/spreport.vue'
import queryStatus from './views/sppro/queryStatus.vue'

//呼叫系统
import callScript from './views/callsys/callScript.vue'
import useCallScript from './views/callsys/useCallScript.vue'
import taskList from './views/callsys/taskList.vue'


let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',
        //leaf: true,//只有一个节点
        children: [
            { path: '/Index', component: Index, name: '首页' },
            { path: '/LoginOut', component: LoginOut, name: '退出' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '权限维护',
        iconCls: 'el-icon-menu',
        children: [
            { path: '/Roleuser', component: Roleuser, name: '用户管理' },
            { path: '/MenusList', component: MenusList, name: '菜单管理' },
            { path: '/Roles', component: Roles, name: '权限管理' },
            { path: '/info', component: info, name: '信息管理' },
            { path: '/confJs', component: confJs, name: '脚本' },
            { path: '/baseReport', component: baseReport, name: '报表管理' }
        ]
    },
	{
        path: '/',
        component: Home,
        name: '数据查询',
        iconCls: 'el-icon-menu',
        children: [
			{ path: '/sitesinfo', component: sitesinfo, name: '列表' },
			{ path: '/report', component: report, name: '数据查询' },
			{ path: '/reports', component: reports, name: '数据查询' },
			{ path: '/htmlLog', component: htmlLog, name: '日志信息' }
        ]
    },
	{
        path: '/',
        component: Home,
        name: '信息管理',
        iconCls: 'el-icon-menu',
        children: [
			{ path: '/spInfo', component: spInfo, name: '上游' },
			{ path: '/cpinfo', component: cpinfo, name: '渠道' },
			{ path: '/siteList', component: siteList, name: 'Site管理' },
			{ path: '/siteinfo', component: siteinfo, name: '站点' },
			{ path: '/Rtreport9933', component: Rtreport9933, name: '数据报表' },
			{ path: '/checkData', component: checkData, name: '检测数据'  },
			{ path: '/sitesinfoManager', component: sitesinfoManager, name: 'List' },
			{ path: '/jsConf', component: jsConf, name: 'Js数据' },
			{ path: '/cpDzd', component: cpDzd, name: '渠道结算单' }
        ]
    },
	{
        path: '/',
        component: Home,
        name: '学习',
        iconCls: 'el-icon-menu',
        children: [
			{ path: '/dclist', component: dclist, name: '单词记忆' }
        ]
    },
	{
        path: '/',
        component: Home,
        name: 'SPPro',
        iconCls: 'el-icon-menu',
        children: [
			{ path: '/spSpInfo', component: spSpInfo, name: '上游管理' },
			{ path: '/spSpConf', component: spSpConf, name: '业务管理' },
			{ path: '/spCpInfo', component: spCpInfo, name: '渠道管理' },
			{ path: '/spService', component: spService, name: '代码管理' },
			{ path: '/queryList', component: queryList, name: '清单查询' },
			{ path: '/spreport', component: spreport, name: '统计数据' },
			{ path: '/queryStatus', component: queryStatus, name: '退订查询' }
        ]
    },
	{
        path: '/',
        component: Home,
        name: '呼叫系统',
        iconCls: 'el-icon-menu',
        children: [
			{ path: '/callScript', component: callScript, name: '话术市场' },
			{ path: '/useCallScript', component: useCallScript, name: '公司使用话术' },
			{ path: '/taskList', component: taskList, name: '任务管理' }
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
	
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js